import React from 'react';
import Button from '@material-ui/core/Button';
import text from './text';

const language = window.location.hash === '#en' ? 'eng' : 'hun';


export default ({filterReset}) => {
  return (
    <div className="filterReset center">
      <Button
            color="primary"
            onClick={ e => filterReset()}
          >
            {text[language].filterReset}
      </Button>
    </div>
  );
}